import { cn } from '@/lib/utils'

/**
 * The VOYP mark as rendered inside the app.
 *
 * Uses `public/logo.png` (the Android `drawable-nodpi/logo.png`) rather than
 * the `public/icons/` set, because those are opaque app-icon *tiles*: they bake
 * in a white background plus asymmetric padding (21px top, 48px bottom at
 * 192px), which reads as a white square on the dark sidebar. Same artwork, but
 * this one has a transparent background so it sits on either theme.
 *
 * The icons/ set is still the right thing for the favicon and apple-touch-icon
 * — see index.html.
 */
export function Logo({ className }: { className?: string }) {
  return (
    <img
      src="/logo.png"
      alt="VOYP"
      width={256}
      height={256}
      className={cn('size-6 shrink-0', className)}
    />
  )
}
